module.exports = __webpack_public_path__ + "res/landing_en.b9442b85e0f29bccfc365683ee0ed048.mp4";